import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { obtenerUniversidades } from "../../Redux/autocompletados"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalComites = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const [universidades, setUniversidades] = React.useState([])
    const loadingUniversidades = useSelector((store) => store.autocompletados.loadingUniversidades);

    React.useEffect(() => {
        if (token) {
            dispatch(obtenerUniversidades(token))
        }
    }, [token]);

    React.useEffect(() => {
        if (loadingUniversidades?.length > 0) {
            const universidades = [];
            loadingUniversidades.forEach((item) => {
                const object = {
                    value: item.new_universidadid,
                    label: item.new_name,
                };
                universidades.push(object);
            });
            setUniversidades(universidades);
        }
    }, [loadingUniversidades])


    const defaultValues = {
        new_institucinconvocante: '',
        new_tipodeevaluacin: '',
        new_lugar: '',
        new_fecha: '',
    }

    const validacionSchema = yup.object().shape({
        new_institucinconvocante: yup.object({ value: yup.string().required("El tipo de carrera es requerido") }),
        new_tipodeevaluacin: yup.number().required("Required"),
        new_lugar: yup.string().required("Required"),
        new_fecha: yup.string().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    const opcionesTipoEv = [
        { label: 'Jurado de Concurso', value: 100000000 },
        { label: 'Jurado de Tésis', value: 100000001 },
        { label: 'Evaluación de Becarios', value: 100000002 },
        { label: 'Evaluación de Investigadores', value: 100000003 },
        { label: 'Evaluación de Programas y Proyectos', value: 100000004 },
        { label: 'Evaluación de Instituciones', value: 100000005 },
        { label: 'Evaluación para Comité Editorial', value: 100000006 },
        { label: 'Evaluación y/o Acreditación de Carreras de Grado y Posgrado', value: 100000007 },
        { label: 'Otro', value: 100000008 },
    ]


    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear participación en comités y jurados</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={universidades}
                                type="text"
                                name="new_institucinconvocante"
                                lab="Organismo o Institución Convocante"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_tipodeevaluacin"
                                label="Tipo de evaluación"
                                helperText="Por favor seleccione un valor"
                                options={opcionesTipoEv}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_lugar"
                                label="Lugar"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el lugar."
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ mt:2 }}>
                            <CustomDateField
                                name="new_fecha"
                                label="Fecha:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalComites